export const baseURL = `https://api.sampleapis.com/wines`